var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{key:_vm.cKey,staticClass:"l-1",class:_vm.counter !== 0 ? _vm.firstChildOnly : ''},_vm._l((_vm.data),function(treenode){return _c('organization-item',{key:treenode.name,attrs:{"orgObject":treenode,"nodes":treenode.orgs,"hasChildren":treenode.hasChildren,"id":treenode.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }